// extracted by css-extract-rspack-plugin
export default {"badge":"ESRK_","badgeLabel":"y_2TL"};